import type { ReactNode } from 'react';

// Matches the production app's `.empty-state` (dashed border, muted center
// text) — used whenever a list/section genuinely has nothing to show yet,
// as distinct from LoadingState (still fetching) and ErrorState (failed).
export function EmptyState({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`rounded-xl border border-dashed border-ink-border px-5 py-8 text-center text-sm text-slate-500 ${className}`}>
      {children}
    </div>
  );
}
